function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect } from 'react';
import { Grid, Row, Col, Space, Avatar, Badge } from 'antd';
import classnames from 'classnames';
import Typography from "../typography";
import HomeMenu from "../home-menu/index";
import defaultAvatar from "./style/avatar.svg";
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LayoutHeader = function LayoutHeader(_ref) {
  var hiddenIglooIcon = _ref.hiddenIglooIcon,
    _ref$menus = _ref.menus,
    menus = _ref$menus === void 0 ? [] : _ref$menus,
    _ref$defaultSelected = _ref.defaultSelected,
    defaultSelected = _ref$defaultSelected === void 0 ? '' : _ref$defaultSelected,
    selectedKey = _ref.selectedKey,
    onMenuChange = _ref.onMenuChange,
    dropMenuConfig = _ref.dropMenuConfig,
    userName = _ref.userName,
    _ref$userAvatar = _ref.userAvatar,
    userAvatar = _ref$userAvatar === void 0 ? defaultAvatar : _ref$userAvatar,
    children = _ref.children;
  var useBreakpoint = Grid.useBreakpoint;
  var _useBreakpoint = useBreakpoint(),
    md = _useBreakpoint.md;
  var _useState = useState(selectedKey),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMenu = _useState2[0],
    setSelectedMenu = _useState2[1];
  var _useState3 = useState(defaultSelected),
    _useState4 = _slicedToArray(_useState3, 2),
    activeMenu = _useState4[0],
    setActiveMenu = _useState4[1];
  var onlyHaveIconButNotShow = hiddenIglooIcon && menus.length === 0 && Object.keys(dropMenuConfig || {}).length === 0 && !userName && !children;
  useEffect(function () {
    if (selectedKey) {
      setSelectedMenu(selectedKey);
    }
  }, [selectedKey]);
  var defaultMenuOnClick = function defaultMenuOnClick(menuConfig) {
    var key = menuConfig.key;
    setActiveMenu(key);
  };
  function getMenuDom(activeMenu, menuInfo) {
    var badge = menuInfo.badge;
    switch (_typeof(badge)) {
      case 'string':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            className: classnames({
              'active-menu': activeMenu === menuInfo.key
            }),
            level: activeMenu === menuInfo.key ? 'h4' : 'body1',
            children: menuInfo.title
          }), /*#__PURE__*/_jsx(Badge, {
            dot: true,
            color: '#F52209'
          })]
        });
      case 'number':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            className: classnames({
              'active-menu': activeMenu === menuInfo.key
            }),
            level: activeMenu === menuInfo.key ? 'h4' : 'body1',
            children: menuInfo.title
          }), /*#__PURE__*/_jsx(Badge, {
            count: badge,
            style: {
              backgroundColor: '#F52209'
            }
          })]
        });
      case 'object':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            className: classnames({
              'active-menu': activeMenu === menuInfo.key
            }),
            level: activeMenu === menuInfo.key ? 'h4' : 'body1',
            children: menuInfo.title
          }), /*#__PURE__*/_jsx(Badge, _objectSpread({}, badge))]
        });
      case 'undefined':
        return /*#__PURE__*/_jsx(Typography, {
          className: classnames({
            'active-menu': activeMenu === menuInfo.key
          }),
          level: activeMenu === menuInfo.key ? 'h4' : 'body1',
          children: menuInfo.title
        });
      case 'function':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            className: classnames({
              'active-menu': activeMenu === menuInfo.key
            }),
            level: activeMenu === menuInfo.key ? 'h4' : 'body1',
            children: menuInfo.title
          }), badge()]
        });
    }
  }
  if (onlyHaveIconButNotShow) return null;
  if (md) {
    return /*#__PURE__*/_jsx("div", {
      className: classnames({
        'igloo-layout-header': true,
        'igloo-layout-header-fix': Boolean(menus === null || menus === void 0 ? void 0 : menus.length) || Boolean(dropMenuConfig)
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: classnames('header-content', {
          'header-content-noSpaceBetween': children
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "header-left",
          children: [!hiddenIglooIcon && /*#__PURE__*/_jsx("div", {
            className: "igloo-logo"
          }), Boolean(menus === null || menus === void 0 ? void 0 : menus.length) && !children && /*#__PURE__*/_jsx(Row, {
            children: menus.map(function (menu) {
              return /*#__PURE__*/_jsx(Col, {
                className: classnames('menu-item'),
                onClick: function onClick() {
                  onMenuChange ? onMenuChange(menu) : defaultMenuOnClick(menu);
                },
                children: getMenuDom(selectedMenu || activeMenu, menu)
              }, menu.key);
            })
          })]
        }), dropMenuConfig && !children && /*#__PURE__*/_jsxs(Space, {
          size: 8,
          children: [/*#__PURE__*/_jsx(Avatar, {
            size: 32,
            src: userAvatar
          }), /*#__PURE__*/_jsx(Typography, {
            level: "body1",
            style: {
              color: '#666666'
            },
            children: userName
          }), dropMenuConfig && /*#__PURE__*/_jsx(HomeMenu, _objectSpread({}, dropMenuConfig))]
        }), children]
      })
    });
  } else {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: classnames({
          'igloo-layout-header': true,
          'igloo-layout-header-fix': Boolean(menus === null || menus === void 0 ? void 0 : menus.length) || Boolean(dropMenuConfig)
        }),
        children: [!hiddenIglooIcon && /*#__PURE__*/_jsx("div", {
          className: "igloo-logo"
        }), dropMenuConfig && !children && /*#__PURE__*/_jsx(HomeMenu, _objectSpread({
          userAvatar: userAvatar,
          userName: userName
        }, dropMenuConfig)), children]
      }), Boolean(menus === null || menus === void 0 ? void 0 : menus.length) && /*#__PURE__*/_jsx(Row, {
        className: "igloo-layout-menu",
        children: menus.map(function (menu) {
          var span = 24 / menus.length;
          return /*#__PURE__*/_jsx(Col, {
            span: span,
            className: classnames('menu-item'),
            onClick: function onClick() {
              onMenuChange ? onMenuChange(menu) : defaultMenuOnClick(menu);
            },
            children: /*#__PURE__*/_jsx("div", {
              style: {
                display: 'flex',
                alignItems: 'flex-start'
              },
              children: getMenuDom(selectedMenu || activeMenu, menu)
            })
          }, menu.key);
        })
      })]
    });
  }
};
LayoutHeader.displayName = 'LayoutHeader';
export default LayoutHeader;